export enum ApplicationIdentifier {
  CMKnowledge,
  CMThread,
  CMBuilder,
  CMExE
}

export enum SubscriptionState {
  Active,
  Expired,
  Overfull,
  None
}
